// extracted by mini-css-extract-plugin
export var container = "_dg-0";
export var infoIcon = "_dg-2";
export var internalLabel = "_dg-3";
export var titleRowCol = "_dg-1";